<template>
  <div id="company-person">
    <mainHeader class="mainHeader" @logout="logoutClick"></mainHeader>
    <div class="wrapper">
      <div class="section section1">
        <span class="title">选择经办人</span>
        <span class="right" @click="goBackClick">返回上一步 ></span>
      </div>
      <div class="section section2">
        <div class="button" @click="addPersonClick">+ 新增经办人</div>
      </div>
      <div class="section section3">
        <div class="input-box" v-on:click="personClick">
          <span>经办人</span>
          <input placeholder="请选择" v-model="personInfo.name" readonly="readonly" unselectable="on" />
          <div></div>
        </div>
      </div>
    </div>
    <bottomButton id="bottomButton" title="下一步" :state="bottomState"  @click="bottomClick"></bottomButton>
    <!--  地址选择  -->
    <SPicker :show="showPicker" type="4" @selectedSPicker="selectedSPicker"></SPicker>
  </div>
</template>

<script>
// import wxShare from '../wx/weixin.js'
import { Toast } from 'mint-ui'
import SPicker from '../components/single-picker'
import mainHeader from '../view/header'
import bottomButton from '../components/bottom-button'

export default{
  inject: ['reload'], // 界面刷新
  data () {
    return {
      showPicker: false,
      bottomState: 0,
      planId: 0,
      personInfo: {
        id: 0,
        name: ''
      } // 选择经办人信息
    }
  },
  methods: {
    logoutClick: function () { // 退出登录
      this.$router.push({path: 'home'})
    },
    goBackClick: function () {
      this.$router.go(-1)
    },
    personClick: function () {
      this.showPicker = true
    },
    selectedSPicker: function (value) {
      this.showPicker = false
      if (value.length <= 0) {
        return
      }
      this.personInfo = value
    },
    addPersonClick: function () {
      this.choosePerson(0)
    },
    bottomClick: function () {
      this.choosePerson(1)
    },
    choosePerson: function (type) {
      var param = {}
      if (type === 0) {
        param = {
          solutions_id: this.planId
        }
      } else {
        if (this.utils.isNull(this.personInfo.name)) {
          Toast('请选择经办人')
          return
        }
        param = {
          solutions_id: this.planId,
          esign_id: this.personInfo.id
        }
      }
      console.log(param)
      var _this = this
      this.utils.POST(this.accountUrl + '/ESign/chosePerson', param, function (response) {
        if (type === 1) { // 已选择经办人
          console.log('==================1111111')
          _this.loadState()
        } else {
          _this.$router.push({path: 'company-auth', query: {planId: _this.planId}})
        }
      })
    },
    loadState: function () {
      var _this = this
      // 获取单子状态  是否下单
      this.utils.GET(this.accountUrl + '/zxOrder/consultingOrderStatus?sId=' + this.planId, function (response) {
        let data = response.data
        // -1说明此id的方案咨询记录不存在 0未生成订单 1订单已生成
        // contract_online_status  合同展示字段[待实名 待认证 待授权 待签署 签署完成]
        if ((data.contract_online_status === '待实名' && data.check_status === '已选择') ||
          data.contract_online_status === '待认证' ||
          data.contract_online_status === '待授权') {
          _this.$router.push({path: 'company-auth', query: {planId: _this.planId}})
        }
        if (data.contract_online_status === '待签署') {
          // contract_status  合同签署参考字段  // 跳转 签署合同
          console.log('状态==========================5 待签署')
          if (parseInt(localStorage.getItem('isApp')) === 1 && _this.utils.isIphone()) { // ios app 内嵌网页 签署合同
            window.webkit.messageHandlers.contractSign.postMessage({'planId': _this.planId})
          } else {
            _this.$router.push({path: 'auth-online', query: {planId: _this.planId}})
          }
        }
        if (data.contract_online_status === '签署完成') {
          // 跳转 已签署详情页
          console.log('状态==========================6 签署完成')
          _this.$router.push({path: 'emergency-detail', query: {planId: _this.planId}})
        }
      })
    },
    loadData: function () {
      this.planId = this.$route.query.planId
    }
  },
  components: {
    mainHeader,
    bottomButton,
    SPicker
  },
  watch: {
    isActive: function (val) {
      if (val === true) {
        this.bottomState = 1
      } else {
        this.bottomState = 0
      }
    }
  },
  computed: { // 计算
    isActive: function () {
      if (this.personInfo.name.length <= 0) {
        return false
      }
      return true
    }
  },
  mounted () {
    // 微信 分享
    // wxShare.wxRegister('在线提问，为你解忧', '写出您的消防问题，数百位行业专家在线答疑', 'http://cdn.zxzx119.com/4689248674381824')
    // 登录状态
    var _this = this
    this.utils.isUserLogin(function (login) {
      console.log('==========' + login)
      if (login === 0) {
        Toast('您还未登录，请登录后再咨询！')
        _this.$router.push({path: 'login', query: {back: 1}})
      } else {
        _this.loadData()
      }
    })
  }
}

</script>

<style scoped>
  .mainHeader{
    position: fixed;
    top: 0px;
    height: 55px;
    width: 100%;
    z-index: 500;
  }
  .wrapper{
    position: absolute;
    height: 100%;
    width: 100%;
    margin-top: 55px;
    background-color: #F1F1F1;
  }
  .section{
    position: relative;
    width: 100%;
    background-color: #FFFFFF;
  }
  .section1{
    height: 60px;
    box-sizing: border-box;
    border-bottom: #F1F1F1 solid 10px;
  }
  .section1 .title{
    height: 50px;
    line-height: 50px;
    color: #000;
    font-size: 16px;
    font-weight: bold;
    margin-left: 15px;
  }
  .section1 .right{
    position: absolute;
    right: 15px;
    height: 50px;
    line-height: 50px;
    color: #999999;
    font-size: 13px;
    font-weight: bold;
  }
  .section2{
    height: 65px;
    background-color: #F1F1F1;
  }
  .section2 .button{
    position: absolute;
    top: 5px;
    left: 15px;
    right: 15px;
    height: 45px;
    line-height: 45px;
    font-size: 13px;
    color: #C41A34;
    text-align: center;
    border: solid #FE9797 0.6px;
    box-sizing: border-box;
    border-radius: 4px;
    background-color: #FFFFFF;

  }
  .section3{
    height: 55px;
    background-color: #FFFFFF;
  }
  .section3 .input-box{
    position: relative;
    width: 100%;
    height: 55px;
    line-height: 55px;
    box-sizing: border-box;
    border-bottom: #eeeeee solid 1px;
  }
  .section3 .input-box span{
    padding-left: 15px;
    width: 100px;
    font-size:15px;
    color: #323232;
  }
  .section3 .input-box input{
    position: absolute;
    top: 10px;
    left: 90px;
    width: calc(100% - 115px);
    height: 35px;
    line-height: 35px;
    font-size:15px;
    color: #000000;
    box-sizing: border-box;
    border: none;
    /*background-color: antiquewhite;*/
  }
  .section3 .input-box div{
    position: absolute;
    left: calc(100% - 20px);
    top: 22px;
    width: 6px;
    height: 10px;
    background-image: url(../assets/next.png);
    background-size: cover;
    background-position: center center;
  }
</style>



// WEBPACK FOOTER //
// src/view/company-person.vue